export const globalSearchEvents = {
  openMenu: 'clicked-on-find-navigation-menu',
  chooseResult: 'clicked-on-result',
  chooseRecent: 'clicked-on-recent-result',
  searchCompleted: 'search-completed',
};
